import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";

const { Types, Creators } = createActions(
  {
    success: ["data"],
    reset: [],
  },
  { prefix: "FILTER_ORDER_FOB_" }
);

export interface FilterOrderFOBState {
  data: any | null;
}

interface SuccessFilterOrderFOB {
  data: any;
}

const INITIAL_STATE: FilterOrderFOBState = {
  data: null,
};

const success = (state: FilterOrderFOBState, action: SuccessFilterOrderFOB) =>
  update(state, {
    data: { $set: action.data },
  });

const reset = () => INITIAL_STATE;

export const filterOrderFOB = createReducer(INITIAL_STATE, {
  [Types.SUCCESS]: success,
  [Types.RESET]: reset,
});

export const FilterOrderFOBTypes = Types;
export const FilterOrderFOBActions = Creators;
